import { createContext, useContext, useMemo, useState } from "react";
import { InventoryItemContainerProps } from "./components/InventoryItemSlot/InventoryItemContainer";
import PageFramework from "../../common/components/layout/PageFramework/PageFramework";
import { useSearchParams } from "react-router-dom";
import CharacterSheetContainer from "./components/CharacterSheet/CharacterSheetContainer";
import NoCharacterContainer from "./NoCharacterContainer";
import InventoryItemTransferContext from "../../utils/sys/InventoryItemTransferContext";

export default function CharacterPage(): JSX.Element {
    const [searchParams, _] = useSearchParams();
    const [
        inventoryItemTransferTargetItemContainer,
        setInventoryItemTransferTargetItemContainer,
    ] = useState<InventoryItemContainerProps | null>(null);

    const characterIDs = useMemo((): Array<number> => {
        return searchParams
            .getAll("id")
            .flatMap((id) => {
                const numID = Number.parseInt(id);

                return Number.isNaN(numID) ? [] : numID;
            })
            .filter((_, index) => index < 5);
    }, [searchParams]);

    const inventoryItemTransferContext = {
        transferTargetItemContainer: inventoryItemTransferTargetItemContainer,
        setTransferTargetItemContainer:
            setInventoryItemTransferTargetItemContainer,
    };

    return (
        <PageFramework noPadding={characterIDs.length > 0}>
            <InventoryItemTransferContext.Provider
                value={inventoryItemTransferContext}
            >
                {characterIDs.length === 0 && <NoCharacterContainer />}
                {characterIDs.length > 0 &&
                    characterIDs.map((characterID) => (
                        <CharacterSheetContainer
                            key={`character-sheet-container-${characterID}`}
                            characterID={characterID}
                            applyDocumentTitle={characterIDs.length === 1}
                        />
                    ))}
            </InventoryItemTransferContext.Provider>
        </PageFramework>
    );
}
